import React from 'react';

const BtnOutlined = ({ title, className = '', btnCb, disabled = false, type = 'button' }) => {
  return (
    <button
      disabled={disabled}
      onClick={() => btnCb()}
      type={type}
      className={`
  ${className} 
  bg-transparent 
  w-full 
  truncate 
  border 
  rounded-full 
  py-2 
  px-4 
  font-semibold 
  ${disabled ? 'text-gray-300 border-gray-300' : 'border-gray-800 hover:bg-orange-50 text-black hover:text-orange-500 hover:border-orange-500'}
`}>
      {title}
    </button>
  );
};

export default BtnOutlined;
